import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { InoutManagementService } from '../../core/services/inout-management.service';
import { StudioService } from '../../core/services/studio.service';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';

const IS_ENTRIES = [
  { id: 0, value: '出口' },
  { id: 1, value: '入口' },
];

@Component({
    selector: 'app-inout-management',
    imports: [FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 一覧 <span>(全 {{ items.length }} 件)</span></span>
        </div>
        <div class="card-body">
          <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
        </div>
        <div class="card-body">
          <button class="btn btn-outline-info" type="button" (click)="sync()" [disabled]="disableButton">
            <span class="material-symbols-outlined align-bottom">{{ disableButton ? 'sync_disabled' : 'sync' }}</span> 同期
          </button>
        </div>
        <div class="card-body">
          @if (loading) {
            <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
          }
          @if (!loading && items.length === 0) {
            <span>該当するデータはありません</span>
          }
          @if (items.length > 0) {
            <table class="table table-bordered table-sm table-hover table-ptb-0">
              <thead>
                <tr>
                  <th colspan="3" width="50%">KEYVOX</th>
                  <th colspan="2" width="50%">システム</th>
                </tr>
                <tr>
                  <th>場所</th>
                  <th>ドア</th>
                  <th>デバイス数</th>
                  <th>選択店舗</th>
                  <th>入口/出口</th>
                </tr>
              </thead>
              <tbody>
                @for (item of items; track item.unitId) {
                  <tr style="cursor:pointer" tabindex="0" (click)="setSelect(item)"
                    (keydown.enter)="setSelect(item)" (keydown.space)="$event.preventDefault(); setSelect(item)">
                    <td>{{ item.placeName }}</td>
                    <td>{{ item.unitName }}</td>
                    <td>{{ item.deviceCount }}</td>
                    <td>{{ item.studio?.name }}</td>
                    <td>
                      @if (item.isEntry === null || item.isEntry === undefined) {
                        <span></span>
                      } @else {
                        <span>{{ item.isEntry ? '入' : '出' }}口</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      </div>
    </div>
  </div>
</div>

@if (showModal && select) {
  <div class="modal-backdrop fade show" (click)="closeModal()"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">編集</h5>
          <button type="button" class="close" (click)="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form novalidate #myEditForm="ngForm">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <label class="col-md-4 col-form-label">場所</label>
                <label class="col-md-8 col-form-label">{{ select.placeName }}</label>
              </div>
              <div class="form-group row">
                <label class="col-md-4 col-form-label">ドア</label>
                <label class="col-md-8 col-form-label">{{ select.unitName }}</label>
              </div>
              <div class="form-group row">
                <label class="col-md-4 col-form-label">関連付けデバイス数</label>
                <label class="col-md-8 col-form-label">{{ select.deviceCount }}</label>
              </div>
              <hr>
              <div class="form-group row align-items-center">
                <label class="col-md-4 col-form-label">紐づけ店舗</label>
                <div class="col-md-8 col-form-label">
                  <select class="form-control" id="studio_id" name="studio_id"
                    [(ngModel)]="select.studioId">
                    <option [ngValue]="null">未選択</option>
                    @for (studio of studios; track studio.id) {
                      <option [ngValue]="studio.id">{{ studio.name }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label class="col-md-4 col-form-label">入口/出口</label>
                <div class="col-md-8 col-form-label">
                  <select class="form-control" id="is_entry" name="is_entry"
                    [(ngModel)]="select.isEntry">
                    <option [ngValue]="null">未選択</option>
                    @for (entry of isEntries; track entry.id) {
                      <option [ngValue]="entry.id">{{ entry.value }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="closeModal()">
            <i class="fa s-icon-cancel"></i>&nbsp;閉じる
          </button>
          @if (select.deviceCount === 1) {
            <button type="submit" class="btn btn-success" (click)="save()" [disabled]="myEditForm.invalid">
              <i class="fa s-icon-save fa-fw"></i>&nbsp;保存
            </button>
          }
        </div>
        </form>
      </div>
    </div>
  </div>
}
  `
})
export class InoutManagementComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private inoutManagementService = inject(InoutManagementService);
  private studioService = inject(StudioService);
  private flash = inject(FlashService);

  items: any[] = [];
  studios: any[] = [];
  isEntries = IS_ENTRIES;
  loading = true;
  disableButton = false;
  showModal = false;
  select: any = null;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('マスター管理', 's-icon-master');
    this.studios = await this.studioService.list('all') ?? [];
    await this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    try {
      this.items = await this.inoutManagementService.getAll() ?? [];
    } finally {
      this.loading = false;
    }
  }

  async sync(): Promise<void> {
    if (!this.disableButton) {
      await this.inoutManagementService.syncInoutUnits();
      this.disableButton = true;
      await this.load();
      // 旧版 inout-management.js:30-42
      this.flash.create('success', 'KEYVOXドア情報を取り込みました。');
      setTimeout(() => { this.disableButton = false; }, 10000);
    }
  }

  setSelect(item: any): void {
    this.select = JSON.parse(JSON.stringify(item));
    this.showModal = true;
  }

  async save(): Promise<void> {
    const json = {
      studioId: this.select.studioId,
      isEntry: this.select.isEntry,
      unitId: this.select.unitId,
    };
    const result = await this.inoutManagementService.update(json);
    if (result === 'ER_DUP_ENTRY') {
      const studioName = this.studios.find(item => item.id === json.studioId)?.name ?? '';
      const entryName = this.isEntries.find(item => item.id === json.isEntry)?.value ?? '';
      // 旧版 inout-management.js:57-63: 重複はdanger、それ以外success
      this.flash.create('danger', `${studioName} の ${entryName} はすでに設定されています。`);
    } else {
      this.flash.create('success', 'データを更新しました。');
    }
    this.closeModal();
    await this.load();
  }

  closeModal(): void {
    this.showModal = false;
    this.select = null;
  }
}
